interface PageHeaderMenu {
    show: boolean;
}
export const usePageHeaderMenu = () => {
    const pageHeaderMenu = useState<PageHeaderMenu>('page-header-menu', () => ({ show: false }))

    const setShow = (show: boolean) => pageHeaderMenu.value.show = show

    return {
        pageHeaderMenu,
        setShow,
    }
}